import form from '@/mixins/crud-form';
import utils from '@/utils';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'MARKET_ADMIN_DETAIL',
        create: 'MARKET_ADMIN_CREATE',
        update: 'MARKET_ADMIN_UPDATE'
      },
      dialog: {
        width: '900px',
        height: '900px'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      return [{
        prop: 'market_id',
        default: utils.cookies.get('market_id'),
        label: this.$t('market_id'),
        show: false,
        col: {
          span: 16
        },
        // render: () => <d2-dict-select name="form_market_id" vModel={ this.form.model.market_id } custom />
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.market_id,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "market_id", $$v);
              }
            }
          });
        }
      }, {
        prop: 'admin_account',
        default: '',
        label: this.$t('admin_account'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.admin_account,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "admin_account", $$v);
              }
            }
          });
        }
      }, {
        prop: 'admin_pwd',
        default: '',
        label: this.$t('admin_pwd'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.admin_pwd,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "admin_pwd", $$v);
              }
            }
          });
        }
      }];
    }
  }
};